import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import xss from 'xss';
import { getAllChannelsGroupedByIds } from '@wix/wix-vod-shared/common';
import {
  ChannelSeoData as BaseChannelSeoData,
  getSeoData as getBaseSeoData,
  GetSeoDataParams,
  VideoSeoData as BaseVideoSeoData,
} from '../../worker/helpers/getSeoData';
import { getVideosGroupedByIds } from '../../selectors/videos';
import { withWidgetProps } from '../../containers/widget-props';
import { OldWidgetProps } from '../../index';
import { RootState } from '../../redux/root-state';
import { Channel, Video } from '../../redux/types';

interface ChannelSeoData extends BaseChannelSeoData {
  '@context': 'http://schema.org';
  '@type': 'MediaObject';
}
interface VideoSeoData extends BaseVideoSeoData {
  '@context': 'http://schema.org';
  '@type': 'VideoObject';
}

interface SeoData extends ChannelSeoData {
  videos: VideoSeoData[];
}

function getSeoData({ channel, videos }: GetSeoDataParams): SeoData {
  const baseSeoData = getBaseSeoData({ channel, videos });
  return {
    '@context': 'http://schema.org',
    '@type': 'MediaObject',
    ...baseSeoData,
    videos: baseSeoData.videos.map((video) => ({
      '@context': 'http://schema.org',
      '@type': 'VideoObject',
      ...video,
    })),
  };
}

interface WidgetProps {
  captureException: (error: Error) => void;
}
interface OwnProps {}
interface DispatchProps {}
interface StateProps {
  channels: Channel[];
  videos: Video[];
}

type Props = OwnProps & StateProps & DispatchProps & WidgetProps;

class SeoComponent extends React.Component<Props> {
  shouldComponentUpdate() {
    return false;
  }
  render() {
    const { channels, videos } = this.props;

    let serializedSeoData = null;

    try {
      const seoData = getSeoData({
        channel: channels[0],
        videos,
      });
      serializedSeoData = seoData && JSON.stringify(seoData);
    } catch (err) {
      this.props.captureException(err as Error);
    }

    if (!serializedSeoData) {
      return null;
    }

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: xss(serializedSeoData),
        }}
      />
    );
  }
}

const selector = ({ captureException }: OldWidgetProps) => ({
  captureException,
});

const mapStateToProps: MapStateToProps<StateProps, OwnProps, RootState> = (
  state,
) => ({
  channels: Object.values(getAllChannelsGroupedByIds(state)),
  videos: Object.values(getVideosGroupedByIds(state)).filter(
    (video) => video.id,
  ),
});
export default withWidgetProps(selector)(
  connect<StateProps, void, OwnProps, RootState>(mapStateToProps)(SeoComponent),
);
